import styled from '@emotion/styled';

export const TypeCardRoot = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '1.75rem',
  borderRadius: '16px',
  cursor: 'pointer',
  background: theme.palette.background.paper,
  border: '1px solid rgba(15, 23, 42, 0.06)',
  transition: 'border-color 160ms ease',
  outline: 'none',
  '&:hover': {
    borderColor: theme.palette.primary.main,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: '2px',
    boxShadow: `0 0 0 3px ${theme.palette.primary.main}33`,
    borderColor: theme.palette.primary.main,
  },
}));

export const TypeCardIconWrap = styled.div(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `${theme.palette.primary.main}14`,
  color: theme.palette.primary.main,
  fontSize: '1.6rem',
}));

export const TypeCardTitle = styled.div(({ theme }) => ({
  fontSize: '1.25rem',
  fontWeight: 600,
  lineHeight: 1.25,
  color: theme.palette.text.primary,
}));

export const TypeCardDescription = styled.div(({ theme }) => ({
  fontSize: '0.95rem',
  lineHeight: 1.45,
  color: theme.palette.text.secondary,
}));
